// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k2bIb","colBig":"styles_colBig__AXs1P","colSmall":"styles_colSmall__2mWRx"};